// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToastBar-module_toastBar__GcUsz {
    left: 0;
    position: fixed;
    right: 0;
    top: 24px;
    pointer-events: none;
    z-index: 10001;
}

.ToastBar-module_toastBarInner__ovEj5 {
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 24px;
    padding-right: 24px;
}

.ToastBar-module_toastBarContent__j8_L1 {
    color: #FFFFFF;
    background-color: #000000;
    border-radius: 12px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    pointer-events: initial;
    cursor: pointer;
}

@media (prefers-color-scheme: dark) {
    .ToastBar-module_toastBarContent__j8_L1 {
        color: #000000;
        background-color: #FFFFFF;
    }
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/ToastBar/ToastBar.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,eAAe;IACf,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,qHAAqH;IACrH,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;IAC7B;AACJ","sourcesContent":[".toastBar {\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 24px;\n    pointer-events: none;\n    z-index: 10001;\n}\n\n.toastBarInner {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 432px;\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n.toastBarContent {\n    color: #FFFFFF;\n    background-color: #000000;\n    border-radius: 12px;\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n    padding: 16px 24px;\n    pointer-events: initial;\n    cursor: pointer;\n}\n\n@media (prefers-color-scheme: dark) {\n    .toastBarContent {\n        color: #000000;\n        background-color: #FFFFFF;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toastBar": `ToastBar-module_toastBar__GcUsz`,
	"toastBarInner": `ToastBar-module_toastBarInner__ovEj5`,
	"toastBarContent": `ToastBar-module_toastBarContent__j8_L1`
};
export default ___CSS_LOADER_EXPORT___;
